import { InfoIcon } from 'lucide-react'

// Reusable Checkbox Field Component
// hint: aclaración opcional que se muestra al pasar el mouse, para no alargar
// la etiqueta (por ejemplo, que un permiso gasta cupos pagados).
const CheckboxField: React.FC<{
  label: string
  name: string
  value: string
  checked: boolean
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  hint?: string
}> = ({ label, name, value, checked, handleInputChange, disabled, hint }) => (
  <div className="flex items-center">
    <input
      type="checkbox"
      name={name}
      value={value}
      className="scale-150 mr-2"
      checked={checked}
      onChange={handleInputChange}
      disabled={disabled}
    />
    <label title={hint}>
      {label}
      {hint && (
        <InfoIcon className="inline-block w-3.5 h-3.5 ml-1 align-text-top text-gray-400 cursor-help" aria-hidden />
      )}
    </label>
  </div>
)
export default CheckboxField
